var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-loader',{attrs:{"condition":_vm.project !== null},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('create-project',{attrs:{"model":_vm.project}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }